function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 .25a3.75 3.75 0 013.745 3.55l.005.2h5.5a.75.75 0 01.102 1.493l-.102.007h-1.059l-1.22 15.053A3.75 3.75 0 0113.233 24H6.767a3.75 3.75 0 01-3.738-3.447L1.808 5.5H.75a.75.75 0 01-.743-.648L0 4.75a.75.75 0 01.648-.743L.75 4h5.5A3.75 3.75 0 0110 .25zm6.687 5.25H3.313l1.211 14.932A2.25 2.25 0 006.767 22.5h6.466a2.25 2.25 0 002.243-2.068L16.686 5.5zM7.75 9.25a.75.75 0 01.743.648L8.5 10v8a.75.75 0 01-1.493.102L7 18v-8a.75.75 0 01.75-.75zm4.5 0a.75.75 0 01.743.648L13 10v8a.75.75 0 01-1.493.102L11.5 18v-8a.75.75 0 01.75-.75zM10 1.75a2.25 2.25 0 00-2.245 2.096L7.75 4h4.5l-.005-.154A2.25 2.25 0 0010 1.75z",
  fill: "#6264a7"
});

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgDelete;